import { render, staticRenderFns } from "./EventPopupFooter.vue?vue&type=template&id=5a6c38d2&scoped=true&"
import script from "./EventPopupFooter.vue?vue&type=script&lang=ts&"
export * from "./EventPopupFooter.vue?vue&type=script&lang=ts&"
import style0 from "./EventPopupFooter.vue?vue&type=style&index=0&id=5a6c38d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a6c38d2",
  null
  
)

export default component.exports